<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" title="Volver" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinnerGuardar" [disabled]="!habilitarGuardar" title="Guardar" (click)="saveSolicitud()" type="button" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinnerGuardar" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>

            <!--<button class="btn btn-outline-success" (click)="cargarDatosPrueba()"><i class="fa fa-long-arrow-up"></i> CARGAR DATOS</button>-->

        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">{{editTitle}} Atestación {{refAtestFito}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitudAtestFito}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitudAtestFito}}">{{codigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{form.value.IdTipoSolicitudAtestFito | IconoTipoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitudAtestFito}}" />
                <img class="estado-icono-big" container="body" src="{{form.value.IdEstadoSolicitudAtestFito | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloEstadoSolicitudAtestFito}}" />
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <!--DETALLE ATESTACION FITOSANITARIA-->
                <div class="row">
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn" style="margin-top: 3px">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Detalle Atestación Fitosanitaria
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">
                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">Comunidad Autónoma</label>
                                            <ng-select [items]="listComunidad"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdComunidadAutonoma"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listComunidad || listComunidad.length === 0"
                                                       [loading]="!listComunidad || listComunidad.length === 0"
                                                       notFoundText="Comunidad Autónoma no encontrada"
                                                       placeholder="-- Seleccione una Comunidad Autónoma --"
                                                       clearAllText="Eliminar selección">
                                            </ng-select>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">Provincia</label>
                                            <ng-select [items]="listProvincia"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdProvincia"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listProvincia || listProvincia.length === 0"
                                                       [loading]="!listProvincia || listProvincia.length === 0"
                                                       notFoundText="Provincia no encontrada"
                                                       placeholder="-- Seleccione una Provincia --"
                                                       clearAllText="Eliminar selección">
                                            </ng-select>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">País Destino</label>
                                            <ng-select [items]="listPais"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPaisDestino"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listPais || listPais.length === 0"
                                                       [loading]="!listPais || listPais.length === 0"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País --"
                                                       clearAllText="Eliminar selección">
                                            </ng-select>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--DATOS SOLICITANTE-->
                <div class="row">
                    <div class="col-md-12">

                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedSolicitante = !isCollapsedSolicitante" [attr.aria-expanded]="!isCollapsedSolicitante" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos Solicitante
                                    <i *ngIf="isCollapsedSolicitante" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedSolicitante" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">

                                <div class="collapse group-filtros" id="isCollapsedSolicitante" [ngbCollapse]="isCollapsedSolicitante">
                                    <div class="row">
                                        <div class="form-group col-md-9">
                                            <label class="col-form-label" for="">Ref. Solicitante</label>
                                            <input formControlName="RefSolicitante" name="RefSolicitante" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="50">
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inpFecha">Fecha prevista de Inspección</label>
                                            <p-calendar formControlName="FechaInspeccion" [ngClass]="displayFieldCssCal('FechaInspeccion')" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaInspeccion','required')">
                                                Fecha Inspección es obligatoria
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                <!--DATOS EXPORTADOR-->
                <div class="row">
                    <div class="col-md-12">

                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedExportador = !isCollapsedExportador" [attr.aria-expanded]="!isCollapsedExportador" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos Exportador
                                    <i *ngIf="isCollapsedExportador" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedExportador" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">

                                <div class="collapse group-filtros" id="collapsedExportador" [ngbCollapse]="isCollapsedExportador">

                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="">NIF</label>
                                            <div class="input-group">
                                                <input formControlName="NifExportador" name="NifExportador" title="" class="form-control" maxlength="9"
                                                       [ngClass]="displayFieldCss('NifExportador')" id="" type="text" value="">
                                            </div>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifExportador','required')">
                                                NIF es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifExportador','NIF')">
                                                Formato de NIF incorrecto
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label required-field" for="">Nombre</label>
                                            <input formControlName="NombreExportador" name="NombreExportador" [ngClass]="displayFieldCss('NombreExportador')" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="300">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreExportador','required')">
                                                Nombre es obligatorio
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">País</label>
                                            <ng-select [items]="listPais"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPaisExportador"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listPais || listPais.length === 0"
                                                       [loading]="!listPais || listPais.length === 0"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País --"
                                                       [ngClass]="displayFieldCssNgSelect('IdPaisExportador')"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>

                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisExportador','required')">
                                                País es obligatorio
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="">Ciudad</label>
                                            <input formControlName="CiudadExportador" name="CiudadExportador" [ngClass]="displayFieldCss('CiudadExportador')" title="" class="form-control" id="inpCiudad" type="text" value="" maxlength="100">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CiudadExportador','required')">
                                                Ciudad es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="">Dirección</label>
                                            <input formControlName="DireccionExportador" name="DireccionExportador" title="" class="form-control" id="inpDireccion" type="text" value="" maxlength="250">

                                            <!--<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('DireccionExportador','required')">
                                    Dirección es obligatoria
                                </div>-->
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="">Código Postal</label>
                                            <input formControlName="CodigoPostalExportador" name="CodigoPostalExportador" [ngClass]="displayFieldCss('CodigoPostalExportador')" title="" class="form-control" id="" type="text" value="" maxlength="15">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoPostalExportador','required')">
                                                Código Postal es obligatorio
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <!--DATOS DEL ENVíO DE LA SOLICITUD-->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedDatosEnvio = !isCollapsedDatosEnvio" [attr.aria-expanded]="!isCollapsedDatosEnvio" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos del envío de la solicitud
                                    <i *ngIf="isCollapsedDatosEnvio" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDatosEnvio" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedDatosEnvio" [ngbCollapse]="isCollapsedDatosEnvio">
                                    <div class="row">
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpFecha">Fecha Envío: </label>
                                            <input formControlName="FechaEnvio" name="FechaEnvio" readonly title="" class="form-control" id="" value="">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">Ref. Atestación: </label>
                                            <input formControlName="RefAtestFito" name="RefAtestFito" readonly title="" class="form-control" id="" type="text" value="">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">PIN: </label>
                                            <input formControlName="Pin" name="Pin" readonly title="" class="form-control" id="" type="text" value="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--TERMINOS Y CONDICIONES-->
                <div class="row">
                    <div class="col-md-12">

                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedTerminosCondiciones = !isCollapsedTerminosCondiciones" [attr.aria-expanded]="!isCollapsedTerminosCondiciones" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Terminos y Condiciones
                                    <i *ngIf="isCollapsedTerminosCondiciones" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedTerminosCondiciones" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <!--<div class="empty-grid" style="padding-left: 0px !important">Debe marcar al menos una de las siguientes casillas:</div>-->

                                <div class="row">
                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="inpFecha">Es responsabilidad del exportador conocer todos los requisitos fitosanitarios exigidos por el país tercero de destino de la mercancía, se compromete al cumplimiento de los mismos y adjunta la siguiente documentación que lo justifica:  </label>
                                    </div>
                                </div>

                                <div class="collapse group-filtros" id="collapsedTerminosCondiciones" [ngbCollapse]="isCollapsedTerminosCondiciones">
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label required-field required-field-relative" for="">Declaración responsable (Anexo IV - RD 387/2021)</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="DeclaracionResponsable" [ngClass]="displayFieldCssToggleButton('DeclaracionResponsable')" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('DeclaracionResponsable','required')">
                                                Es obligatorio aceptar la Declaración responsable
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="">Licencia o permiso de importación</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="CheckLicencia" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="">Normativa fitosanitaria vigente del país de destino</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="CheckNormativa" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-md-12">
                                            <label class="col-form-label" for="">* Nota: En caso de que se requiera pagar Tasa para la emisión de este informe por la Comunidad Autónoma, se adjuntará el justificante de pago en Documentos</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>

</form>


